import { useState, useEffect } from "react";
import type { Goal, DbGoal } from "@/types/goal";
import type { RealtimePostgresChangesPayload } from "@supabase/supabase-js";
import { goalService, convertToAppGoal } from "../services/goalService";

export const useGoals = () => {
	const [goals, setGoals] = useState<Goal[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<Error | null>(null);

	useEffect(() => {
		const fetchGoals = async () => {
			try {
				const data = await goalService.getGoals();
				setGoals(data);
			} catch (err) {
				setError(err as Error);
			} finally {
				setLoading(false);
			}
		};

		fetchGoals();

		// リアルタイム更新のサブスクリプション
		const subscription = goalService.subscribeToChanges(
			(payload: RealtimePostgresChangesPayload<DbGoal>) => {
				if (payload.eventType === "INSERT") {
					setGoals((prev) => [convertToAppGoal(payload.new), ...prev]);
				} else if (payload.eventType === "UPDATE") {
					setGoals((prev) =>
						prev.map((goal) =>
							goal.id === payload.new.id ? convertToAppGoal(payload.new) : goal,
						),
					);
				} else if (payload.eventType === "DELETE") {
					setGoals((prev) => prev.filter((goal) => goal.id !== payload.old.id));
				}
			},
		);

		return () => {
			subscription.unsubscribe();
		};
	}, []);

	return {
		goals,
		loading,
		error,
		createGoal: goalService.createGoal,
		updateGoal: goalService.updateGoal,
		deleteGoal: goalService.deleteGoal,
	};
};
